import "./RunQuickActionHistory.css";
import {
  MdDocumentScanner,
  MdEdit,
  MdKeyboardBackspace,
  MdPictureAsPdf,
} from "react-icons/md";
import { PiBookOpenText } from "react-icons/pi";
import { FaRegFileAlt } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Run_Quick_Action_History_ActionHandler,
  Run_Quick_Action_History_Success,
} from "../../../Redux/Actions/user/RunQuickActionHistoryAccess";
import {
  Button,
  Dropdown,
  Form,
  Input,
  Modal,
  Space,
  Card,
  Menu,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { ResizableBox } from "react-resizable";
import generatePDF, { Margin } from "react-to-pdf";
import Loader from "../../../Components/Loader/Loader";
import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
import { CgAlignLeft } from "react-icons/cg";
import { BsCodeSlash } from "react-icons/bs";
import TextArea from "antd/es/input/TextArea";
import EditHistoryDrawer from "./EditHistoryDrawer";
import { Save_Edit_Output_History_Action_Handler } from "../../../Redux/Actions/user/SaveEditHistoryRunQa";
import { Restored_Output_EditHistory_Action_Handler } from "../../../Redux/Actions/user/RestoredOutputEditHistoryRunQa";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CiCircleInfo } from "react-icons/ci";

const RunQuickActionHistory = () => {
  const preBuiltSvg = "/assets/prebuilit_icon.svg";
  const Navigate = useNavigate();
  const [formForSaveEditHistory] = Form.useForm();
  const params = useParams();
  const [form] = Form.useForm();
  const targetRef = useRef();
  const dispatch = useDispatch();
  const [historyData, setHistoryData] = useState({});
  const [isOutputEditorIsReadOnly, setIsOutputEditorIsReadOnly] =
    useState(true);
  const [openEditHistory, setOpenEditHistory] = useState(false);
  const [
    isModalVisibleForSaveEditHistory,
    setIsModalVisibleForSaveEditHistory,
  ] = useState(false);
  const [RestoreData, setRestoreData] = useState("");
  let [editorContent, setEditorContent] = useState(
    historyData?.result?.response
  );

  const Run_historydata = useSelector(
    (state) =>
      state?.Run_Quick_Action_History_Access_Data?.run_Quick_Action_History_data
  );

  const [isRestored, setIsRestored] = useState(false);

  useEffect(() => {
    if (params?.id) {
      dispatch(Run_Quick_Action_History_ActionHandler(params?.id, Navigate));
    }
    return () => {
      setHistoryData({});
      dispatch(Run_Quick_Action_History_Success(null));
    };
  }, []);

  useEffect(() => {
    if (Run_historydata) {
      setHistoryData(Run_historydata?.data);
    }
  }, [Run_historydata]);

  useEffect(() => {
    if (historyData) {
      let initialValue = {
        name: historyData.name,
      };
      form.setFieldsValue(initialValue);

      let responseData = historyData?.result?.response;
      if (responseData != undefined) {
        if (!(responseData.indexOf("<table") !== -1)) {
          responseData = responseData.replace(/\n/g, "<br>");
        }

        setEditorContent(responseData);

        if (hasHtmlTags(responseData)) {
          setisHtml(true);
        }
      }
    }
    setIsQuickActionIsRestricted(historyData?.is_restricted);
    // Open all Links of Desc in new tab
    const links = document.querySelectorAll(".description-card a");

    // Set target="_blank" for each anchor tag
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer"); // Security best practice
    });
  }, [historyData]);

  const [isHtml, setisHtml] = useState(false);
  const [isQuickActionIsRestricted, setIsQuickActionIsRestricted] =
    useState(false);

  function hasHtmlTags(str) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = str;

    return tempElement.children.length > 0; // Check if there are child elements (tags)
  }

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorContent(data);
  };

  const editorRef = useRef(null);

  const Run_historydataLoader = useSelector(
    (state) => state?.Run_Quick_Action_History_Access_Data?.loader
  );

  const handleIsOutputEditorIsReadOnly = () => {
    setIsOutputEditorIsReadOnly(!isOutputEditorIsReadOnly);
  };

  const showEditHistoryDrawer = () => {
    setOpenEditHistory(!openEditHistory);

    setTimeout(() => {
      const parent = document.getElementsByClassName("ant-drawer-mask");
      for (let i = 0; i < parent?.length; i++) {
        parent[i].style.background = "none";
      }
    }, 500);
  };

  const handleCancelForSaveEditHistory = () => {
    setIsModalVisibleForSaveEditHistory(false);
  };

  const closeEditHistoryDrawer = () => {
    setOpenEditHistory(false);
  };

  useEffect(() => {
    if (params?.id) {
      dispatch(Run_Quick_Action_History_ActionHandler(params?.id, Navigate));
    }
    return () => {
      setHistoryData({});
      dispatch(Run_Quick_Action_History_Success(null));
    };
  }, []);

  useEffect(() => {
    if (Run_historydata) {
      setHistoryData(Run_historydata?.data);
    }
  }, [Run_historydata]);

  ///batch output data
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const downloadPdf = () => {
    targetRef.current.style.display = "block";

    generatePDF(targetRef, {
      filename: (historyData?.name || "QA RUN Output") + ".pdf",
      paperSize: "A4",
      page: {
        margin: Margin.MEDIUM,
        format: "A4",
      },
    });
    targetRef.current.style.display = "none";
  };

  const downloadDoc = async () => {
    try {
      const filename = (historyData?.name || "QA RUN Output") + ".docx";
      editorContent = editorContent.replace(
        /<td/g,
        "<td style='padding: 10px;border: 1px solid black !important;'"
      );
      editorContent = editorContent.replace(
        /<th>/g,
        "<th style='padding: 10px;border: 1px solid black !important;'>"
      );
      editorContent = editorContent.replace(
        "<table",
        "<table style='border-collapse: collapse !important;border-spacing: 0;'"
      );

      var converted = htmlDocx.asBlob(editorContent, {
        orientation: "portrait",
        margins: { top: 720 },
      });
      saveAs(converted, filename);
    } catch (err) {
      console.error("Error generating DOCX:", err);
    }
  };

  const items = [
    {
      label: (
        <p className="download-option" onClick={downloadPdf}>
          <MdPictureAsPdf />
          Download in Pdf
        </p>
      ),
    },
    {
      type: "divider",
    },
    {
      label: (
        <p className="download-option" onClick={downloadDoc}>
          <MdDocumentScanner />
          Download in Docs
        </p>
      ),
    },
  ];

  const CallRestoreApi = (currentHistoryId, currentEditedHistory) => {
    dispatch(
      Restored_Output_EditHistory_Action_Handler(
        params?.Qaid,
        params?.id,
        currentHistoryId
      )
    );

    setIsRestored(!isRestored);
    currentEditedHistory = currentEditedHistory.replace(/\n/g, "<br>");
    setEditorContent(currentEditedHistory);
  };

  const handleGoBack = () => {
    Navigate(-1);
  };

  let prompthtml = historyData?.entered_prompt;

  if (prompthtml != undefined) {
    prompthtml = prompthtml.replace(/\n/g, "<br>");
  }

  let promptformattedHtml = (
    <div dangerouslySetInnerHTML={{ __html: prompthtml }}></div>
  );
  if (typeof promptformattedHtml == "string") {
    promptformattedHtml = prompthtml
      .split("<br>")
      .map((str, index) => <p key={index}>{str}</p>);
  }

  const handleCopyToClipboard = async () => {
    try {
      targetRef.current.style.display = "block";
      var editor = document.getElementById("response_output");

      var range = document.createRange();
      range.selectNodeContents(editor);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy"); // change
      targetRef.current.style.display = "none";
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Copied successfully!",
        showConfirmButton: false,
        timer: 1000,
      });
    } catch (err) {
      console.warn("Unable to copy to clipboard.", err);
    }
  };

  const handleCopyToClipboardHTML = async () => {
    try {
      await navigator.clipboard.writeText(historyData?.result?.response);

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Copied successfully!",
        showConfirmButton: false,
        timer: 1000,
      });
    } catch (err) {
      console.warn("Unable to copy to clipboard.", err);
    }
  };

  const onFinishSaveEditHistory = (values) => {
    setIsModalVisibleForSaveEditHistory(false);

    let request = {
      edited_output: editorContent,
      ...values,
    };
    dispatch(
      Save_Edit_Output_History_Action_Handler(request, params?.Qaid, params?.id)
    );
    formForSaveEditHistory.resetFields();
    setEditorContent(editorContent);
    setIsOutputEditorIsReadOnly(!isOutputEditorIsReadOnly);
  };

  return (
    <>
      {Run_historydataLoader && <Loader />}
      <div className="run-history-main">
        <div className="run-quickaction-container">
          {(historyData?.quickAction?.custom_qa_v_id === null ||
            historyData?.quickAction?.custom_qa_v_id === undefined) &&
          !isQuickActionIsRestricted ? (
            <div>
              <Card className="run-quickaction_1">
                <h3> Reference data </h3>

                <div className="run-card-eye">
                  {historyData?.supporting_documents?.map((document, index) => (
                    <div key={index}>
                      <div>
                        <PiBookOpenText />
                        {document?.name}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>

              <Card className="run-quickaction_1">
                <h3> Output Format </h3>

                <div className="run-card-eye">
                  {historyData?.output_formats?.map((document, index) => (
                    <div key={index}>
                      <div>
                        <FaRegFileAlt />
                        {document?.name}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>

              <Card className="run-quickaction_card2">
                <h3>Prompt</h3>
                {historyData?.action_prompt}
              </Card>
            </div>
          ) : historyData?.quickAction?.custom_qa_v_id !== null ||
            historyData?.quickAction?.custom_qa_v_id !== undefined ? (
            <div>
              <Card
                className="run-quickaction_1"
                style={{ height: "fit-content" }}
              >
                <div>
                  <button
                    className="pre-built-btn"
                    style={{
                      marginBottom: "20px",
                      padding: "5px 10px",
                      gap: "10px",
                      fontSize: "14px",
                    }}
                  >
                    <img src={preBuiltSvg} alt="" />
                    Pre-built QuickAction
                  </button>
                </div>
                <div style={{ display: "grid" }}>
                  <span>Created by</span>
                  <span
                    style={{
                      fontWeight: "600",
                      marginTop: "15px",
                    }}
                  >
                    {historyData?.folder_logo_url ? (
                      <Tooltip
                        title={historyData?.folder_created_by_name}
                        placement="right"
                      >
                        <img
                          src={historyData?.folder_logo_url}
                          alt="logo"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            margin: "0 5px",
                          }}
                        />
                      </Tooltip>
                    ) : (
                      <>{historyData?.folder_created_by_name} </>
                    )}
                  </span>
                  <span style={{ marginTop: "15px" }}>
                    This QuickAction has been created by{" "}
                    {historyData?.folder_created_by_name}. Please review the
                    instructions below to execute the QuickAction effectively.
                  </span>
                </div>
              </Card>
              {historyData?.quickAction?.description && (
                <Card
                  className="run-quickaction_1"
                  style={{ height: "fit-content" }}
                >
                  <div>
                    <h4 style={{ marginTop: 0 }}>Description</h4>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: historyData?.quickAction?.description,
                    }}
                  />
                </Card>
              )}
            </div>
          ) : (
            <div>
              <Card className="run-quickaction_1" style={{ height: "220px" }}>
                <div>
                  <button
                    className="output-button"
                    style={{
                      marginBottom: "20px",
                      padding: "5px 20px",
                      gap: "10px",
                      fontSize: "14px",
                    }}
                  >
                    <CiCircleInfo
                      style={{
                        color: "red",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    Restricted Access
                  </button>
                </div>
                This QuickAction has been created by{" "}
                <span style={{ fontWeight: "600" }}>
                  {historyData?.quick_action_created_by}
                </span>
                . The view for reference data and prompt has been restricted by
                the owner. For further details, please contact{" "}
                {historyData?.quick_action_created_by}.
              </Card>
              {historyData?.description && (
                <Card
                  className="run-quickaction_1"
                  style={{ height: "fit-content" }}
                >
                  <div>
                    <h4 style={{ marginTop: 0 }}>Description</h4>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: historyData?.description,
                    }}
                  />
                </Card>
              )}
            </div>
          )}

          <div className="history-run-object">
            <div className="run-again-btn">
              <div onClick={handleGoBack}>
                <MdKeyboardBackspace />
                Back
              </div>
            </div>
            {(historyData?.quickAction?.custom_qa_v_id === null ||
              historyData?.quickAction?.custom_qa_v_id === undefined) && (
              <div className="upload-out-computer-main-div">
                <div className="upload-out-computer-span history-run-prompt">
                  <div className="upload-out-computer-middle-div-first-p ">
                    {promptformattedHtml}
                  </div>
                </div>
              </div>
            )}
            <div className="mt-3">
              <div className="chat-upper-batch-output ">
                <div className="buttons">
                  <div
                    className="output-text-main"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "7px",
                    }}
                  >
                    <h5>Output</h5>
                    <div className="flex-batch justify-content-end ">
                      <button className="output-button">
                        {historyData?.name}
                      </button>
                      {isHtml ? (
                        <div className="downlod-div-batch dropdown-header">
                          <img src="/images/copy.svg" className="me-1" alt="" />
                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item>
                                  <p
                                    className="download-option"
                                    onClick={handleCopyToClipboard}
                                  >
                                    <CgAlignLeft className="download-option svg" />
                                    Copy as Text
                                  </p>
                                </Menu.Item>
                                <Menu.Item>
                                  <p
                                    className="download-option"
                                    onClick={handleCopyToClipboardHTML}
                                  >
                                    <BsCodeSlash className="download-option svg" />{" "}
                                    Copy as HTML
                                  </p>
                                </Menu.Item>
                              </Menu>
                            }
                            placement="bottomRight"
                            arrow
                            trigger={["click"]}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                Copy <DownOutlined />
                              </Space>
                            </a>
                          </Dropdown>
                        </div>
                      ) : (
                        <button
                          className="msg-btn-2"
                          onClick={handleCopyToClipboard}
                        >
                          <img
                            src="/images/copy.svg"
                            className="output-img svg"
                          />
                          &nbsp; Copy
                        </button>
                      )}
                      <div className="downlod-div-batch dropdown-header">
                        <img
                          src="/images/icon-dwnld.svg"
                          className="me-1"
                          alt=""
                        />

                        <Dropdown
                          menu={{ items }}
                          placement="bottomRight"
                          arrow
                          trigger={["click"]}
                        >
                          <a onClick={(e) => e.preventDefault()}>
                            <Space>
                              Download <DownOutlined />
                            </Space>
                          </a>
                        </Dropdown>
                      </div>
                      <button
                        className="msg-btn"
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        onClick={handleIsOutputEditorIsReadOnly}
                      >
                        <MdEdit />
                      </button>
                    </div>
                  </div>
                  <div className="message-section-height-data ">
                    <div
                      style={{
                        height: "470px !important",
                      }}
                    >
                      <span>
                        <CKEditor
                          editor={ClassicEditor}
                          data={editorContent}
                          config={{
                            toolbar: [],
                          }}
                          onChange={handleEditorChange}
                          onReady={(editor) => {
                            editorRef.current = editor;
                          }}
                          disabled={isOutputEditorIsReadOnly}
                        />
                      </span>
                    </div>
                  </div>
                  <span
                    ref={targetRef}
                    id="response_output"
                    style={{
                      padding: "10px",
                      position: "relative",
                      fontFamily: "Poppins",
                      display: "none",
                    }}
                  >
                    <div
                      className="hidden-table-css"
                      dangerouslySetInnerHTML={{
                        __html: editorContent,
                      }}
                    ></div>
                  </span>
                  <div className="m-auto" style={{ marginTop: "25px" }}>
                    <button
                      className="view_edit_history"
                      onClick={showEditHistoryDrawer}
                    >
                      View Edit History
                    </button>
                    {isOutputEditorIsReadOnly ? null : (
                      <button
                        className="save_edit_history ml-3"
                        onClick={() =>
                          setIsModalVisibleForSaveEditHistory(true)
                        }
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for save edit history */}
      <Modal
        title="Save Edit History"
        visible={isModalVisibleForSaveEditHistory}
        onOk={() => form.submit()}
        onCancel={handleCancelForSaveEditHistory}
        className="user-management-modal"
      >
        <Form
          form={formForSaveEditHistory}
          onFinish={onFinishSaveEditHistory}
          initialValues={{ title: "", description: "" }}
        >
          <label>
            Enter History Name <span style={{ color: "red" }}>*</span>{" "}
          </label>
          <Form.Item
            name="title"
            className="mt-2"
            rules={[
              {
                required: true,
                message: "Please Enter History Name!",
              },
            ]}
          >
            <Input placeholder="Enter history name" />
          </Form.Item>
          <label>Description</label>
          <Form.Item
            name="description"
            rules={[
              {
                required: false,
                message: "Describe what you have changed",
              },
            ]}
          >
            <TextArea placeholder="Enter description here" rows="5" />
          </Form.Item>
          <Form.Item>
            <button type="submit" className="model-btn-submit-management">
              Save
            </button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Drawer for Edit output history */}
      {openEditHistory && (
        <EditHistoryDrawer
          setRestoreData={setRestoreData}
          closeEditHistoryDrawer={closeEditHistoryDrawer}
          callRestoreApi={CallRestoreApi}
          isRestored={isRestored}
          openEditHistory={openEditHistory}
          ActionId={params?.id}
          QaID={params?.Qaid}
        />
      )}
    </>
  );
};

export default RunQuickActionHistory;
